import { getUITranslation } from "../utils/get_ui_translation";

const ID_START_DATE = "js-partial-absence-start-date";
const ID_END_DATE = "js-partial-absence-end-date";
const PREFIX_RADIO_BUTTON_ID = "js-section-radio-";
const ID_SECTION_ALL_SUBSESSIONS = "js-training-session-slot-selector";
const ID_SELECT_TYPE_PARTIAL_ABSENCE = "js-select-type-partial-absence";
const ID_INPUT_RECORDED_TIME = "js-recorded-time";

document.getElementById(ID_SELECT_TYPE_PARTIAL_ABSENCE)?.addEventListener("change", () => {
  change_recorded_time_label();
});

document.getElementById(ID_START_DATE)?.addEventListener("change", () => {
  filter_slots();
});
document.getElementById(ID_END_DATE)?.addEventListener("change", () => {
  filter_slots();
});

function change_recorded_time_label() {
  const select_type_partial_absence = document.getElementById(ID_SELECT_TYPE_PARTIAL_ABSENCE);
  const selected_value = select_type_partial_absence.value;
  const recorded_time_label = document.getElementById(ID_INPUT_RECORDED_TIME)?.closest("label")?.querySelector("span");

  if (selected_value === "delay") {
    recorded_time_label.innerText = getUITranslation("Heure d'arrivée");
  } else {
    recorded_time_label.innerText = getUITranslation("Heure de départ");
  }
}

function is_between_date(startDate, endDate, currentDate) {
  if (!startDate && !endDate) {
    return true;
  }
  if (!startDate && endDate) {
    return new Date(currentDate) <= new Date(endDate);
  }
  if (startDate && !endDate) {
    return new Date(currentDate) >= new Date(startDate);
  }

  if (startDate && endDate) {
    currentDate = new Date(currentDate);
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    return currentDate >= startDate && currentDate <= endDate;
  }
}

function filter_slots() {
  const startDate = document.getElementById(ID_START_DATE).value;
  const endDate = document.getElementById(ID_END_DATE).value;
  const section_all_subsessions = document.getElementById(ID_SECTION_ALL_SUBSESSIONS);

  section_all_subsessions.querySelectorAll('input[type="radio"]:not(:checked)').forEach(function (c) {
    const dateSlot = c.getAttribute("data-date-slot");
    const slotId = c.getAttribute("data-ts-slot-id");

    if (slotId) {
      if (is_between_date(startDate, endDate, dateSlot)) {
        document.getElementById(PREFIX_RADIO_BUTTON_ID + slotId).hidden = false;
      } else {
        document.getElementById(PREFIX_RADIO_BUTTON_ID + slotId).hidden = true;
      }
    }
  });

  // Hide containers without visible slots & dividers
  document.querySelectorAll(".partial-absence-slot-selector").forEach(function (detailSubsession) {
    if (detailSubsession.querySelectorAll(".js-section-radio:not([hidden])").length > 0) {
      detailSubsession.hidden = false;

      detailSubsession.querySelectorAll(".js-slot-divider").forEach(function (divider) {
        divider.hidden = true;
      });

      let isFirstHidden = true;
      detailSubsession.querySelectorAll(".js-section-radio").forEach(function (slot) {
        if (!slot.hidden) {
          const divider = slot.querySelector(".js-slot-divider");
          if (divider) {
            divider.hidden = isFirstHidden;
          }
          isFirstHidden = false;
        }
      });
    } else {
      detailSubsession.hidden = true;
    }
  });
}
